<template lang="pug">
    .row
        .form-col.large-10
          validation-provider(rules="required" v-slot="{ errors }", :name="`${cf.name}_yesno`")
            input.hidden(type="radio" v-model="checked")
            .radio-switch
                .radio-switch-label
                    .medical-radio-buttons
                        .field.radio-field.negative.no-uncheck(:class="{checked: checked}")
                            label.no-custom(@click="check(true)" :class="{error: errors[0]}")
                                input.no-custom(type="radio" :checked="checked===true" required)
                                .label-text {{t('app.general._yes')}}
                        .field.radio-field.positive.no-uncheck(:class="{checked: checked===false}")
                            label.no-custom(@click="check(false, true)" :class="{error: errors[0]}")
                                input.no-custom(type="radio" :checked="checked===false" required)
                                .label-text {{t('app.general._no')}}
                    label {{cf.name}}
        .form-col.large-14
            div(v-if="checked")
                //changed from v-show in order for this 32696 to work
                custom-field(
                  v-model="tmpValue"
                  :required="checked",
                  :custom_field="cf"
                  @change="onChange" :entity_selected="!disabled"
                )
            .field(v-show="!checked && isPresent(cf.description)")
                WithRequired(:require="false",:text="cf.description",:cut_text="true", :length="70-8")
                br
</template>
<script>
import CustomField from "../../form_block/_custom_field"
import WithRequired from '../../shared/_with_required'
export default {
  components: {CustomField,WithRequired},
  props: {
    cf:         {type: Object, required: true},
    filled:     {type: Number, required: false}, //can be null
    value:      {type: Array, required: true, default: ()=>([])},
  },
  // when data has been fetched we copy existing values to the memory
  // after that on the page we manipulate with memory data
  emits: {
    change: {},
    input: {},
  },
  data(){
    return {
      checked: null,
      tmpValue: null,
    }
  },
  computed: {
    disabled(){ return !this.state.current_reg.person_id},
  },
  mounted(){ // had do repeat this code due to ticket 32696. Leaving it like that right now, to be sure it works
      this.fillData()
  },
  watch: {
    value(){  this.fillData() },
    checked(){ this.onChange() },
  },
  methods:{
    fillData(){
      this.tmpValue = this.value
      this.checked = this.cf_checked()
      this.onChange()
    },
    check(val, setEmpty=false){
      if (this.disabled) return
      if (setEmpty) this.tmpValue = ['']
      this.checked = val
    },
    onChange(evt){
      const sending = evt ? evt : this.tmpValue
      this.$emit("input", sending)
      this.$emit("change", sending)
    },
    cf_checked(){
      if(!this.value)             return null
      if(this.value.length === 0) return null

      for (const val of this.value){
        if (this.isPresent(val)) return true
      }
      return false
    },
  },
}
</script>
